import { getCurrentInstance } from '@/util'

import type { Confirm } from '..'

export default function useConfirm() {
  const instance = getCurrentInstance()

  function c(...args: Parameters<Confirm>) {
    return instance.proxy.$confirm(...args)
  }

  return { confirm: c }
}
